exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3rAFB15swy3ROb{color:#5e6c84;display:block;margin:35px auto;text-align:center;max-width:600px}._3rAFB15swy3ROb h1{font-size:26px;margin-top:20px;margin-bottom:24px}._3rAFB15swy3ROb p{font-size:18px;line-height:22px}", ""]);

// exports
exports.locals = {
	"errorMessage": "_3rAFB15swy3ROb"
};